<template>
  <div>
    <header :class="`${section.header.class}`">
      <div class="container">
        <slot name="header"></slot>
      </div>
    </header>

    <section :class="`top-divider ${section.topdivider.class}`">
      <div class="container">
        <div class="row">
          <div class="col-lg-12"></div>
        </div>
      </div>
    </section>

    <section :class="`content-wrapper ${section.content.class}`">
      <div>
        <slot name="content"></slot>
      </div>
      <div class="container">
        <div class="row scrollto-top-wrapper">
          <div class="col s12">
            <i
              class="material-icons scroll-to-top-button"
              v-scroll-into-view="scrollElem"
              >expand_less</i
            >
          </div>
        </div>
      </div>
    </section>
    <footer
      :class="`footer-wrapper blue-grey darken-4 ${section.footer.class}`"
    >
      <div class="dashed-border">
        <div class="container">
          <slot name="footer">
            <base-footer />
          </slot>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import BaseFooter from "./base-footer.component";
import { ScrollIntoView } from "../directives/ScrollIntoView.directive";

export default {
  name: "base-template",

  components: {
    "base-footer": BaseFooter
  },

  directives: {
    ScrollIntoView
  },

  data() {
    let section = Object.assign(
      {
        header: {
          class: ""
        },
        topdivider: {
          class: ""
        },
        content: {
          class: ""
        },
        scrolltotop: {
          class: ""
        },
        footer: {
          class: ""
        }
      },
      this.tmpls
    );

    return {
      section
    };
  },

  props: {
    tmpls: {
      type: Object
    },

    // selector to a DOM node
    scrollElem: {
      type: String,
      default() {
        return "#app";
      }
    }
  }
};
</script>

<style scoped></style>
